export const useSetupNotifications = () => {
  return;
};
